import React from "react";

// A compact visual signature for Remy: a clinical speech bubble with a live
// pulse line. It deliberately uses only SVG primitives so it stays crisp at
// toolbar and conversation-avatar sizes without introducing another asset.
export default function RemyMark({
  size = 24,
  color = "currentColor",
  pulseColor = "#076cd8",
  className,
}) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      focusable="false"
      height={size}
      viewBox="0 0 32 32"
      width={size}
    >
      <path
        d="M7 4h18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H16l-6.1 5.1A1.2 1.2 0 0 1 8 26.2V22a3 3 0 0 1-3-3V7a3 3 0 0 1 2-3Z"
        fill={color}
      />
      <path
        d="M9 14.8h3.1l1.7-4.3 3.2 9 2.1-4.7H23"
        fill="none"
        stroke={pulseColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.1"
      />
    </svg>
  );
}
